import { BannerStars } from './BannerStars';

export default BannerStars;
